import { DAppRewardsCenter } from '../modules/rewards/DAppRewardsCenter'

export default function Rewards() {
  return <DAppRewardsCenter />
}
